import { render, staticRenderFns } from "./PointmapRecordDialog.vue?vue&type=template&id=afdf3dc6&"
import script from "./PointmapRecordDialog.vue?vue&type=script&lang=js&"
export * from "./PointmapRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports